if (!customElements.get("vt-slide-swiper")) {
  customElements.define(
    "vt-slide-swiper",
    class VTSlideSwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector(".swiper");
      }
      connectedCallback() {
        this.swiper = new Swiper(this.swiper, {
          // Optional parameters
          loop: true,
          // If we need pagination
          pagination: {
            el: ".swiper-pagination"
          },
          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          },
          // And if we need scrollbar
          scrollbar: {
            el: ".swiper-scrollbar"
          }
        });
      }
    }
  );
}
